export default __webpack_public_path__ + "images/FY.e0d0f7e.png";